<template>
  <b-link class="nav-link favorite-action" :class="{'is-favorite': media.favorite}" @click="onToggle">
    <div class="icon-bg">
      <b-spinner label="Loading..." class="spin" size="sm" v-if="loading"/>
      <Icon name="heart" :width="iconWidth" :class="{'bump': bumping}" v-else/>
    </div>
  </b-link>
</template>

<script>
import notificationAudio from '@/assets/audio/notification.mp3'

export default {
  name: "ToggleFavorite",
  emits: ['toggle'],
  data() {
    return {
      loading: false,
      audio: new Audio(notificationAudio),
      bumping: false
    }
  },
  props: {
    media: {
      type: Object,
      required: true
    },
    iconWidth: {
      required: false,
      type: Number,
      default: 26
    }
  },

  methods: {
    async onToggle() {
      this.$emit('toggle', this.media)
      if (!this.media.favorite) {
        await this.audio.play()
        this.triggerBump()
      }
    },
    triggerBump() {
      this.bumping = true
      setTimeout(() => {
        this.bumping = false
      }, 800)
    }
  },
}
</script>


<style scoped>
@keyframes bump {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1);
  }
}

.bump {
  animation: bump 400ms ease-in-out infinite;
}
</style>